import React, { useState, useEffect, useContext, useRef } from "react";
import {
  VegaFlex,
  VegaInputSelect,
  VegaInput,
  VegaButtonLink,
  VegaFont,
} from "@heartlandone/vega-react";
import { HubContext } from "Redux/Context/context";
import { v4 as uuidv4 } from 'uuid';
const ActivityFormTeam = ({isShow, onValid, activityAllowRoles, isEdit}) => {
  const inputRef = useRef(null);
  const [fieldValue, setFieldValue] = useState(() =>
    (activityAllowRoles || []).map(item => ({ ...item, id: uuidv4() }))
  );
  const [registerNumberLimit, setRegisterNumberLimit] = useState();
  const [isValid, setIsValid] = useState(true);
  const [sourceRoles, setSourceRoles] = useState([]);
  const { dashboardBasicDataState } = useContext(HubContext);
  const { positionClassifications } = dashboardBasicDataState;

  const handleAddNew = () => {
    setFieldValue([...fieldValue, { id: uuidv4(), roleId: "", numbers: "0" }]);
  };

  const handleRoleChange = (index, roleId) => {
    fieldValue[index].roleId = roleId;
    setFieldValue([...fieldValue]);
  };

  const handleNumberChange = (index, value) => {
    fieldValue[index].numbers = Number(value);;
    setFieldValue([...fieldValue]);
  };

  const handleDelete = (index) => {
    setFieldValue(prev => {
      const newValue = prev.filter((_, i) => i !== index);
      return newValue;
    });
  };

  const getFilteredRoles = (index) => {
    const selectedIds = fieldValue
      .filter((_, i) => i !== index)
      .map(r => String(r.roleId).trim())
      .filter(id => id !== '' && id !== 'null' && id !== 'undefined');
    return sourceRoles.filter(role => !selectedIds.includes(String(role.id)));
  };

  useEffect(() => {
    if(positionClassifications){
        setSourceRoles(positionClassifications.map((item) => ({
            id: item.id.toString(),
            displayName: item.name,
        })));
    }
    // eslint-disable-next-line
  }, [positionClassifications]);

  useEffect(() => {
    if(registerNumberLimit && fieldValue && fieldValue?.length > 0){
        const sum = fieldValue.reduce(
            (currentValue, item) => Number(item.numbers) + currentValue,
            0,
        );
      setIsValid(sum === Number(registerNumberLimit));
    } else {
      setIsValid(true);
    }
    
    // eslint-disable-next-line
  }, [fieldValue, registerNumberLimit]);

  useEffect( () => {
    const setLimit = async () => {
        if(isShow){
            const form = findParent(inputRef.current, 'vega-form');
            const limit = (await form.getValue()).registerNumberLimit;
            setRegisterNumberLimit(limit);
        }
    }
    setLimit()
    // eslint-disable-next-line
  }, [isShow]);

  useEffect( () => {
    onValid(isValid);
    // eslint-disable-next-line
  }, [isValid]);

  const findParent = (el, selector) => {
	if (!el) return null;
	const parent= el.parentElement;
	return parent?.matches(selector) ? parent : findParent(parent, selector);
 }

  const onValueChange = (e) => {
    setFieldValue(e.detail);
  };

  return (
    <div>
      <VegaInput
        data-vega-form="activityAllowRoles"
        value={fieldValue}
        onVegaChange={onValueChange}
        style={{ display: "none" }}
        ref={inputRef}
      />
      <VegaFlex direction={'col'} gap={'size-24'}>
        {fieldValue.map((roleItem, index) => (
            <VegaFlex
                direction="row"
                alignItems="center"
                gap="size-16"
                key={roleItem.id}
          >
            <div style={{ width: '224px' }}>
                <VegaInputSelect
                    vegaDropdownProps={{
                    searchable: false,
                    }}
                    size="small"
                    label='Position'
                    source={getFilteredRoles(index)}
                    disabled={isEdit}
                    value={roleItem.roleId}
                    onVegaChange={(e) => handleRoleChange(index, e.detail)}
              ></VegaInputSelect>
            </div>
            <div style={{ width: '64px' }}>
                <VegaInput
                    type="number"
                    // required={true}
                    showClearIcon={false}
                    size="small"
                    label='Count'
                    disabled={isEdit}
                    maxLength={9}
                    value={roleItem.numbers}
                    onVegaChange={(e) => handleNumberChange(index, e.target.value)} // 仅更新数量
            />
            </div>
                <VegaButtonLink
                    icon="fa-regular fa-trash"
                    disabled={isEdit}
                    style={{marginTop: '24px'}}
                    onVegaClick={() => handleDelete(index)}
                />
            </VegaFlex>
        ))}
         {!isValid && <VegaFont variant='font-footnote1-short' color="text-error">
            Total Team Recruitment members should be equal to {registerNumberLimit}
        </VegaFont>}
        <VegaButtonLink
            disabled={isEdit}
            onVegaClick={handleAddNew}
        >
            + Add New
        </VegaButtonLink>
      </VegaFlex>
    </div>
  );
};

export default ActivityFormTeam;
